import { render, staticRenderFns } from "./MemberReview.vue?vue&type=template&id=637878c7&scoped=true"
import script from "./MemberReview.vue?vue&type=script&lang=ts"
export * from "./MemberReview.vue?vue&type=script&lang=ts"
import style0 from "./MemberReview.vue?vue&type=style&index=0&id=637878c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637878c7",
  null
  
)

export default component.exports